import React from "react";
import { Box, Chip, Select, MenuItem, Tooltip } from "@mui/material";

function KeyOperatorChips({
  entityConfig,
  keysWithOperators,
  editingKey,
  onDeleteKey,
  onOperatorChange,
  onEditFilter,
}) {
  const fields = entityConfig.entityStructure.fields;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        marginX: 2,
        ...(keysWithOperators.length > 0 && { mb: 2 }),
      }}
    >
      <Box
        sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}
      >
        {keysWithOperators.map(({ key, operator, searchTerm }, index) => {
          const field = fields[key];
          const filterOperators = field?.filterOperators || [];

          // Skip rendering if the field is not found
          if (!field) {
            console.warn(
              `Field "${key}" not found in entityConfig.entityStructure.fields`
            );
            return null;
          }

          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                "& .MuiOutlinedInput-root": { borderRadius: "16px" },
              }}
            >
              <Tooltip
                title={`${field.label}.${operator}${
                  searchTerm ? `=${searchTerm}` : ""
                }`}
                placement="top"
                arrow
              >
                <Chip
                  label={
                    searchTerm
                      ? `${field.label}.${operator}=${searchTerm}`
                      : `${field.label}.${operator}`
                  }
                  onDelete={() => onDeleteKey(key)}
                  onClick={() => onEditFilter(key, searchTerm || "")}
                  sx={{
                    backgroundColor: editingKey === key ? "#ff9800" : "#f39c12",
                    color: "white",
                    maxWidth: "150px",
                  }}
                  size="small"
                />
              </Tooltip>
              <Select
                value={operator}
                onChange={(e) => onOperatorChange(key, e.target.value)}
                size="small"
                sx={{ height: "24px", fontSize: "0.75rem", maxWidth: "150px" }}
              >
                {filterOperators.map((opKey) => (
                  <MenuItem key={opKey} value={opKey}>
                    {opKey}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default KeyOperatorChips;
